import React from 'react';
import { isFreeAddon, getCostForAddon, getCustomCostForAddon } from '../utils';

export const LANGUAGES = {
  EN: 'English (US)',
  ZH: 'Chinese',
  FR: 'French',
  JA: 'Japanese',
  KO: 'Korean',
  AR: 'Arabic',
  CS: 'Czech',
  NL: 'Dutch',
  DE: 'German',
  IT: 'Italian',
  PL: 'Polish',
  PT: 'Portuguese',
  RU: 'Russian',
  ES: 'Spanish',
  TR: 'Turkish'
};

const PREFIX_OVERRIDES = {
  EN: 'us'
};

export const CAPTION_SAMPLES = {
  EN: 'An example subtitle',
  JA: '字幕の例',
  AR: 'مثال الترجمة',
  ZH: '一个示例字幕',
  CS: 'Příklad titulků',
  NL: 'Een voorbeeld ondertitel',
  FR: 'Un exemple de sous-titre',
  DE: 'Ein Beispiel für einen Untertitel',
  IT: 'Un sottotitolo di esempio',
  KO: '자막 예',
  PL: 'Przykładowy podtytuł',
  PT: 'Um exemplo de legenda',
  RU: 'Пример субтитра',
  ES: 'Un subtítulo de ejemplo',
  TR: 'Örnek bir altyazı'
};

export default function () {
  return ({
    billingEntityCode,
    addonsCosts,
    includedAddons,
    customAddonCosts





  }) => (type) => {
    const zeroCost = getCostForAddon({ billingEntityCode, costs: null });
    const CAPTIONS = Object.keys(LANGUAGES).map((languageCode) => {
      const cost = isFreeAddon({ addonKey: type, addonValue: languageCode, includedAddons }) ?
      zeroCost :
      getCostForAddon({ costs: addonsCosts[type].costs, billingEntityCode });

      const addonCost = customAddonCosts && customAddonCosts.length ? getCustomCostForAddon({
        addonType: type,
        customAddonCosts,
        billingEntityCode,
        languageCode
      }) : cost;

      return {
        label: LANGUAGES[languageCode],
        value: languageCode,
        prefix: `flag${PREFIX_OVERRIDES[languageCode] || languageCode.toLowerCase()}`,
        suffix: <span>{addonCost}</span>,
        cost: addonCost
      };
    });

    return CAPTIONS;
  };
}